// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768px","container":"CompactInfoSection_container__jt0l6","mobileReverse":"CompactInfoSection_mobileReverse__G1VUh","mobileCard":"CompactInfoSection_mobileCard__9aJQp"};